import React,{useState} from "react";
import '../components/css/SettingDrawer.css'
import { CircleX,ChevronRight, HomeIcon,User,NotebookPen,CalendarClock, CircleCheckBig, NotepadText, Landmark, ChartNoAxesCombined, Megaphone, FileUser, KeyRound, CircleUserRound, LogOut } from "lucide-react";
import { useNavigate,useLocation } from "react-router-dom";

const SettingDrawer = ({show_settingdrawer,setSettingDrawer})=>{
            const navigate = useNavigate();
    const [student,setStudent] = useState(JSON.parse(localStorage.getItem('student')));

    return(<>
    <div className={`SettingDrawer ${show_settingdrawer ? 'SettingDrawer-open' : 'SettingDrawer-close'}`}>
            
            <div className="SettingDrawer-title">
                      <CircleX onClick={()=>setSettingDrawer(false)}/>  Settings
                        <div></div> 
                    </div>  
 <div className="Avtar-SettingDrawer"  >
               <img src={student.pic != '' ?`https://new.proschoolerp.com/${student.pic}`:'https://www.shutterstock.com/image-vector/vector-funny-cat-glasses-cute-600nw-2313634279.jpg'}/> 
            </div>
            <div className="SettingDrawer-name">
                {student.name}
            </div>
<div className="SettingDrawer-menu_area">
    <br/>
       <div className="drawer-menues">
                
                <div className={`drawer-menu-item `}onClick={() => {
  navigate('account');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <KeyRound/> Account  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                <div className={`drawer-menu-item `} onClick={() => {
  navigate('profile');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <CircleUserRound/> Profile  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                <div className={`drawer-menu-item `}
                
                onClick={() => {
  localStorage.removeItem('student_token');
  localStorage.removeItem('is_stufcm_done');


  navigate('/');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <LogOut/> Logout  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                
                </div>
</div>
        </div>
      
        <div onClick={()=>setSettingDrawer(false)} className={`SettingDrawerOverlay ${show_settingdrawer ? 'SettingDrawer-open_overlay' : 'SettingDrawer-close_overlay'}`}></div>
    
    </>);

}
export default SettingDrawer;